// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:2lWtJw */\n.ZFbtO{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:1fr}.vQQRK{display:flex;flex-direction:column;padding:var(--audio-spacing-8) 0}._2udWP{align-items:center;display:flex;font-size:var(--audio-font-size-17);font-weight:600;letter-spacing:.05em;line-height:var(--audio-line-height-24);margin:0;padding:var(--audio-spacing-8) 0}.C7n9O{font-size:var(--audio-font-size-17);font-weight:400;line-height:var(--audio-line-height-24);margin:0;white-space:break-spaces;word-break:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "ZFbtO",
	"moreInfo": "vQQRK",
	"heading": "_2udWP",
	"description": "C7n9O"
};
export default ___CSS_LOADER_EXPORT___;
